<h1>Appointment Listing</h1>

<app-mat-date-time-picker [label]="'Appointment Time'"  [name]="'appointmentDate'" [processing]="saving" [parentForm]="form" (action)="saveAppointment()" class="col-sm-12" *appPermissionRequired="'Clinical.Appointments.Write'"></app-mat-date-time-picker>
@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
<div class="mat-card-list" *appPermissionRequired="'Clinical.Appointments.Read';">
  @for (appointment of appointments; track appointment.id) {
    <mat-card class="compact">
      <mat-card-content class="pb-0 pt-2">
        <app-appointment-widget [appointment]="appointment" [types]="appointmentTypes" class="w-100"></app-appointment-widget>
      </mat-card-content>
    </mat-card>
  }
  @if (!hasAppointments) {
    <mat-card class="compact">
      <mat-card-content >No appointments have been created for this patient.</mat-card-content>
    </mat-card>
  }
</div>
